module.exports = __webpack_public_path__ + "static/media/ChildInsured_purple.02375bb4.png";